export const TOP_SPACE = 24;
export const LEFT_SPACE = 16;
